<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="checklistItems"
      item-key="id"
    >
      <template v-slot:item.actions="{ item }">
        <v-btn
          @click="edit(item)"
          small
        >
          Edit
        </v-btn>
        <v-btn
          @click="remove(item)"
          class="ml-2"
          small
          color="error"
        >
          Delete
        </v-btn>
      </template>
    </v-data-table>
    <v-btn @click="dialog = true" color="primary">Create New</v-btn>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title>
          <span class="headline">Create checklist item</span>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field v-model="checklistItemName" label="Checklist Name"></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="secondary" @click="closeDialog">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn :loading="isSaving" color="primary" @click="saveChecklist">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListCheckList',
  mixins: [loading],
  props: {
    checklistId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      checklistItemName: '',
      checklistItemId: undefined,
      headers: [
        { text: 'Checklist Item Name', value: 'name' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
    };
  },
  computed: {
    ...mapState('checklistItems', ['checklistItems']),
  },
  mounted() {
    this.refresh();
  },
  methods: {
    ...mapActions('checklistItems', [
      'CREATE_checklistItem',
      'LOAD_checklistItems',
      'UPDATE_checklistItem',
      'DELETE_checklistItem',
    ]),
    edit(checklistItem) {
      this.dialog = true;
      this.checklistItemName = checklistItem.name;
      this.checklistItemId = checklistItem.id;
    },
    async remove(checklistItem) {
      const result = await this.$confirm('Are you sure you want to delete this?');
      if (result) {
        await this.DELETE_checklistItem(checklistItem.id);
        await this.refresh();
      }
    },
    async saveChecklist() {
      // save checklistItem
      const { checklistId, checklistItemName, checklistItemId } = this;
      this.isSaving = true;
      if (!checklistItemId) {
        await this.CREATE_checklistItem({ name: checklistItemName, checklistId });
      } else {
        await this.UPDATE_checklistItem({
          name: checklistItemName,
          id: checklistItemId,
        });
      }
      this.checklistItemName = '';
      this.checklistItemId = undefined;
      this.isSaving = false;
      this.dialog = false;
      await this.refresh();
    },
    closeDialog() {
      this.dialog = false;
    },
    async refresh() {
      this.isLoading = true;
      await this.LOAD_checklistItems(this.checklistId);
      this.isLoading = false;
    },
  },
};
</script>
